/* eslint-disable react/display-name */
import React, { memo } from 'react';

import { translate } from '../../common/translation/translate';
import { StyledLink } from './commonStyle';

interface StatePrivacyLinkProps {
    optOutApiIsLoading: boolean;
    optOutSuccessOccurred: boolean;
    optOutErrorOccurred: boolean;
    isStatePrivacyLink?: boolean;
    isLimitUseOfPILink?: boolean;
    userOptedOutOfStatePrivacy?: boolean;
    userOptedOutOfLimitUseOfPI?: boolean;
    linkCallback: () => void;
}

export const StatePrivacyLinkView = memo(({ 
    optOutApiIsLoading,
    optOutErrorOccurred,
    optOutSuccessOccurred,
    isLimitUseOfPILink,
    isStatePrivacyLink,
    userOptedOutOfLimitUseOfPI,
    userOptedOutOfStatePrivacy,
    linkCallback }: StatePrivacyLinkProps) => {

    if (optOutApiIsLoading) {
        return (
            <>
                <span>
                    {translate('loading')}
                </span>
                &nbsp;|&nbsp;
            </>
                
        );
    }

    if (optOutSuccessOccurred) {
        return (
            <span>
                {translate('confirmed')}
            </span>
        );
    }

    if (optOutErrorOccurred) {
        return (
            <span>
                {translate('error')}
            </span>
        );
    }

    if (isStatePrivacyLink) {
        return (
            <StyledLink onClick={linkCallback}>
                {userOptedOutOfStatePrivacy ? translate('notSellingYourData') : translate('doNotSellMyData')}
            </StyledLink>
        );
    }

    if (isLimitUseOfPILink) {
        return (
            <StyledLink onClick={linkCallback}>
                {userOptedOutOfLimitUseOfPI ? translate('personalInfomationIsLimited') : translate('limitUseOfMySensitivePersonalPersonalInformation')}
            </StyledLink>
        );
    }

    return null;
});

StatePrivacyLinkView.displayName = 'StatePrivacyLinkView';
